import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import GOContact from './pages/global/GOContact';
import Destinations from './pages/global/Destinations';
import Services from './pages/global/Services';
import ProcessPage from './pages/global/Process';
import Success from './pages/global/Success';
import AiChatWidget from './components/AiChatWidget';

function App() {
  return (
    <BrowserRouter>
      <div className="global-app">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/success" element={<Success />} />
          <Route path="/contact" element={<GOContact />} />
        </Routes>
        <Footer />
        <AiChatWidget />
      </div>
    </BrowserRouter>
  );
}

export default App;
